import React from "react";
import { PriorityIndicator } from "./PriorityIndicator";
import { ChevronRight, Loader2 } from "lucide-react";
import { TextWithGlossary } from "./TextWithGlossary";
import priorityMap from "../utils/formatPriority";
import formatDateString from "../utils/formatDateString";
import isFutureDate from "../utils/isFutureDate";
import AreaCardProps from "../types/AreaCardProps";

const LoadingDots = () => {
	return (
		<span className="inline-flex">
			<span className="animate-dot1">.</span>
			<span className="animate-dot2">.</span>
			<span className="animate-dot3">.</span>
		</span>
	);
};

export const AreaCard: React.FC<AreaCardProps> = ({
	area,
	filter,
	onActionClick,
}) => {
	const filteredActions = area.actions.filter(
		(action) => filter === "all" || action.priority === filter
	);

	return (
		<div className="bg-gray-800 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
			<div className="p-6">
				<div className="flex items-center justify-between mb-6">
					<h3 className="text-lg font-semibold text-white">
						<TextWithGlossary>{area.title}</TextWithGlossary>
					</h3>
					<div className="flex items-center gap-2">
						<PriorityIndicator
							priority={
								isFutureDate(area.shippedAt) ? "loading" : area.priority
							}
							size="lg"
						/>
						<span className="text-sm text-gray-400">
							{isFutureDate(area.shippedAt)
								? "Calculando prioridade"
								: `Prioridade ${priorityMap(area.priority)}`}
						</span>
					</div>
				</div>
				<div className="space-y-3">
					{isFutureDate(area.shippedAt) ? (
						<div className="flex items-center gap-3 p-3">
							<Loader2 className="w-5 h-5 text-blue-500 animate-spin" />
							<p className="text-sm text-gray-400">
								Analisando dados
								<LoadingDots /> Próxima atualização:{" "}
								{formatDateString(area.shippedAt)}
							</p>
						</div>
					) : (
						filteredActions.map((action) => (
							<button
								key={action.id}
								onClick={() => onActionClick(action)}
								className="w-full flex items-center gap-3 p-3 rounded-lg hover:bg-gray-700 transition-colors group"
							>
								<PriorityIndicator priority={action.priority} />
								<p className="flex-1 text-sm text-left text-gray-300 group-hover:text-white transition-colors">
									<TextWithGlossary>{action.title}</TextWithGlossary>
								</p>
								<ChevronRight
									size={16}
									className="text-gray-500 group-hover:text-gray-300 transition-colors"
								/>
							</button>
						))
					)}
				</div>
			</div>
		</div>
	);
};
